import { createSelector } from 'reselect';
import { IRoleState } from './types';

const selectRoleState = (state: { role: IRoleState }) => state.role;

export const selectRoleList = createSelector(
  selectRoleState,
  (roleState) => roleState.list
);

export const selectRoleListLoading = createSelector(
  selectRoleState,
  (roleState) => roleState.loading
);

export const selectRoleListError = createSelector(
  selectRoleState,
  (roleState) => roleState.error
);

export const selectRoleListCount = createSelector(
  selectRoleState,
  (roleState) => roleState.list
);